export var DataCatalogTagKind;
(function (DataCatalogTagKind) {
    DataCatalogTagKind["DATA_CATALOG_TAG_KIND_MANAGED"] = "MANAGED";
    DataCatalogTagKind["DATA_CATALOG_TAG_KIND_SYSTEM"] = "SYSTEM";
})(DataCatalogTagKind || (DataCatalogTagKind = {}));
